import Veggie from "../assets/icons/Veggie.svg";
import Sandwich from "../assets/icons/Sandwich.svg";
import Strawberry from "../assets/icons/Strawberry.svg";

const categories = [
  { id: 1, name: "Vegano", icon: Veggie },
  { id: 2, name: "Vegetariano", icon: Sandwich },
  { id: 3, name: "Saudável", icon: Strawberry },
];

export default categories;
